import { KdsText, TagV2 } from "@kazaar-platform/design-system";
import {
  RiAdminLine,
  RiBox3Line,
  RiFlashlightLine,
  RiInboxLine,
  RiLeafLine,
  RiSettings4Line,
  RiShoppingBagLine,
  RiStore2Line,
} from "@remixicon/react";
import {
  type DefaultParamType,
  type TFnType,
  type TranslationKey,
} from "@tolgee/react";
import { PermissionItem } from "@/api/__generated__/orval/auth";
import { type SideBarItem } from "@/components/Layouts";

type GetSidebarItemsType = {
  t: TFnType<DefaultParamType, string, TranslationKey>;
  hasBrokerKazaarRole: boolean;
  taskCount?: number;
  notificationCount?: number;
  userHasPermission: (
    permission: PermissionItem,
    subjectId?: string
  ) => boolean;
};

export const getSidebarItems = ({
  t,
  hasBrokerKazaarRole,
  taskCount,
  notificationCount,
  userHasPermission,
}: GetSidebarItemsType): SideBarItem[] => [
  {
    name: <KdsText size="subtitle-sm">{t("navigation.worklist")}</KdsText>,
    icon: <RiFlashlightLine className="size-sp-md" />,
    href: "/dashboard",
    notificationCount: taskCount,
    visible: true,
  },
  {
    name: (
      <div className="flex items-center gap-sp-xs">
        <KdsText size="subtitle-sm">{t("navigation.inbox")}</KdsText>
      </div>
    ),
    icon: <RiInboxLine className="size-sp-md" />,
    href: "/inbox",
    notificationCount: notificationCount,
    visible: true,
  },
  {
    name: <KdsText size="subtitle-sm">{t("navigation.order.catalog")}</KdsText>,
    icon: <RiStore2Line className="size-sp-md" />,
    href: "/catalog",
    visible: userHasPermission(PermissionItem.imsproductsread),
  },
  {
    name: (
      <KdsText size="subtitle-sm">{t("navigation.order.myOrders")}</KdsText>
    ),
    icon: <RiShoppingBagLine className="size-sp-md" />,
    href: "/orders",
    visible:
      userHasPermission(PermissionItem.omsordersmanagement) ||
      userHasPermission(PermissionItem.omsordersread),
  },
  {
    name: (
      <div className="flex items-center gap-sp-xs">
        <KdsText size="subtitle-sm">{t("navigation.openBrief")}</KdsText>
        <TagV2 variant="alpha" size="sm">
          {t("beta")}
        </TagV2>
      </div>
    ),
    icon: <RiBox3Line className="size-sp-md" />,
    href: "/open-brief",
    visible:
      userHasPermission(PermissionItem.omsordersmanagement) &&
      userHasPermission(PermissionItem.omsbriefsmanagement),
  },
  {
    name: <KdsText size="subtitle-sm">{t("oms.updateEcoScore.title")}</KdsText>,
    icon: <RiLeafLine className="size-sp-md" />,
    href: "/eco-scoring",
    visible:
      userHasPermission(PermissionItem.kazaaradminmanagement) &&
      hasBrokerKazaarRole,
  },

  {
    name: <KdsText size="subtitle-sm">{t("navigation.admin")}</KdsText>,
    icon: <RiAdminLine className="size-sp-md" />,
    href: "/admin",
    visible:
      userHasPermission(PermissionItem.accountsaccountsmanagement) ||
      userHasPermission(PermissionItem.accountsorganizationsmanagement) ||
      userHasPermission(PermissionItem.accountsworkspacesmanagement),
  },
  {
    name: <KdsText size="subtitle-sm">{t("oms.featureFlags.title")}</KdsText>,
    icon: <RiSettings4Line className="size-sp-md" />,
    href: "/settings",
    visible:
      userHasPermission(PermissionItem.kazaaradminmanagement) &&
      hasBrokerKazaarRole,
  },
];
